var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcSource = function SvgIcSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.5h12A3.5 3.5 0 0 1 21.5 6v12a3.5 3.5 0 0 1-3.5 3.5H6A3.5 3.5 0 0 1 2.5 18V6A3.5 3.5 0 0 1 6 2.5Z",
    fill: "#646C6F",
    stroke: "#646C6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.515 15.379a.5.5 0 0 0 .97.242l.28-1.12h1.97l-.22.878a.5.5 0 0 0 .97.242l.28-1.12H15a.5.5 0 1 0 0-1h-.985l.375-1.5h1.11a.5.5 0 1 0 0-1h-.86l.345-1.38a.5.5 0 0 0-.97-.242L13.61 11h-1.97l.345-1.379a.5.5 0 0 0-.97-.242L10.61 11H9.5a.5.5 0 0 0 0 1h.86l-.375 1.5H9a.5.5 0 0 0 0 1h.735l-.22.879Zm3.47-1.879h-1.97l.375-1.5h1.97l-.375 1.5ZM7.18 15.384a.5.5 0 0 0 .64-.768L5.281 12.5l2.54-2.116a.5.5 0 1 0-.641-.768l-3 2.5a.5.5 0 0 0 0 .768l3 2.5Zm9.64-5.768a.5.5 0 0 0-.64.768l2.539 2.116-2.54 2.116a.5.5 0 0 0 .641.768l3-2.5a.5.5 0 0 0 0-.768l-3-2.5Z",
    fill: "currentColor"
  })));
};
export default SvgIcSource;